import React from 'react'

function ProfileCard({ userInfo }) {
  return (
    <div className="user-profile-card">
        <div className="card-content">
        <img src={userInfo && userInfo.profilePicUrl ? userInfo.profilePicUrl : '/assets/img/placeholder.png'} alt={`profile image`} className="profile-image" />
        <div className="text-content">
            <h3 className="name">{userInfo?.firstName} {userInfo?.lastName}</h3>
            <p className="field">{userInfo?.fieldOfMedicine}</p>
        </div>
        </div>
    </div>
  )
}

export default ProfileCard
